<script setup lang="ts">
import { onBeforeUnmount, onMounted } from 'vue';

const props = defineProps<{
  helpers: {
    picture: string;
    position: string;
    size: string;
    blur?: boolean;
  }[];
  containerWidth: number;
  redirectUrl?: string | null;
}>();

let redirectTimeout: ReturnType<typeof setTimeout> | null = null;

onMounted(() => {
  if (!props.redirectUrl) return;

  redirectTimeout = setTimeout(() => {
    window.location.href = props.redirectUrl as string;
  }, 2000);
});

onBeforeUnmount(() => {
  if (redirectTimeout) {
    clearTimeout(redirectTimeout);
  }
});
</script>

<template>
  <div
    data-cy="signup-confirmation"
    class="relative h-full w-full flex-1 text-center"
  >
    <div
      :class="[
        `relative h-[200px] bg-[url('/img/illustration_redirection_background.svg')] bg-cover bg-center md:rounded-t-[15px]`,
        {
          'md:rounded-t-[15px]': containerWidth >= 600
        }
      ]"
    >
      <div
        v-for="(helper, helperIndex) in helpers"
        :key="helperIndex"
        :class="['absolute', helper.position]"
      >
        <div
          :class="[
            'overflow-hidden rounded-full',
            helper.size,
            { 'border-2 border-border-on-emphasis': !helper.blur }
          ]"
        >
          <img class="h-full w-full object-cover" :src="helper.picture" />
        </div>
      </div>
    </div>

    <h3
      class="mx-auto mt-10 max-w-xs text-mgm-txt-xl font-semibold text-foreground-emphasis"
    >
      {{ $t('helpeeCampaignSignUpView.redirection.title') }}
    </h3>

    <p
      class="mx-auto mt-4 max-w-xs text-mgm-txt-sm font-normal text-foreground-default"
    >
      {{ $t('helpeeCampaignSignUpView.redirection.description') }}
    </p>
  </div>
</template>
